import _extends from "@babel/runtime-corejs2/helpers/extends";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { ContextConsumer } from './Context';

var ChromelessControl = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ChromelessControl, _React$PureComponent);

  var _super = _createSuper(ChromelessControl);

  function ChromelessControl() {
    var _this;

    _classCallCheck(this, ChromelessControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.props.setChromelessFloating(true);
    });

    return _this;
  }

  _createClass(ChromelessControl, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-nav-chrome-toggle",
        onMouseEnter: this.onMouseEnter
      });
    }
  }]);

  return ChromelessControl;
}(React.PureComponent);

export default (function (props) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
    var setChromelessFloating = _ref.setChromelessFloating;
    return /*#__PURE__*/React.createElement(ChromelessControl, _extends({}, props, {
      setChromelessFloating: setChromelessFloating
    }));
  });
});